import S from '../Home.module.scss';
import styled from 'styled-components';
import defaultProfileImg from '../assets/default_profile.svg';
import profileImgEx from '../../../common/assets/profile_ex_img.jpeg';
import resumeTitleIcon from '../assets/library_books.svg';
import editIcon from '../assets/edit_pensil.svg';
import { RepresentativeResumeType, ResumeType } from '../../../../types/ResumeTypes';
import _ from 'lodash';
import { DateTimeUtils } from '../../../../utils/DateTimeUtils';
import { useNavigate } from 'react-router-dom';

interface HomeProfileProps {
  resume: RepresentativeResumeType;
}

const HomeProfile = (props: HomeProfileProps) => {
  const { resume } = props;
  const navigate = useNavigate();
  const educationSize = resume.educations?.length || 0;

  return (
    <div className={S.resume_info_area}>
      {/* 기본 인적사항 시작 */}
      <div className={S.user_basic_box}>
        <div className={S.profile_img_area}>
          {_.isEmpty(resume.profile?.profileImageUrl?.mediaUrl) ? (
            <ProfileImg backgroundImage={defaultProfileImg}></ProfileImg>
          ) : (
            <ProfileImg backgroundImage={resume.profile?.profileImageUrl?.mediaUrl}></ProfileImg>
          )}
        </div>
        <div className={S.user_basic_info}>
          <div className={S.user_name_area}>
            <h2 className={`${S.korean_name} h2`}>{resume.profile.localName || ''}</h2>
            {resume.profile.enName !== '' && <span className={S.divider_icon}></span>}
            <h2 className={S.english_name}>{resume.profile.enName || ''}</h2>
          </div>
          <div className={S.user_detail_area}>
            <div className={S.detail_info}>
              <p className={`${S.detail_text} b3`}>
                {resume.profile.birthday}(만 {DateTimeUtils.calculateAge(resume.profile.birthday)}
                세)
              </p>
              <span className={S.divider_icon}></span>
              <p className={`${S.detail_text} b3`}>
                {_.isEmpty(resume.profile.gender)
                  ? ''
                  : resume.profile.gender === 'MEN'
                  ? '남'
                  : '여'}
              </p>
            </div>
            <div className={S.detail_info}>
              <p className={`${S.detail_text} b3`}>{_.isEmpty(resume.profile?.phoneNumber)? '' : `${resume.profile.phoneNumber.slice(0,3)}-${resume.profile.phoneNumber.slice(3,7)}-${resume.profile.phoneNumber.slice(7)}`}</p>
              <span className={S.divider_icon}></span>
              <p className={`${S.detail_text} b3`}>{resume.profile.email || ''}</p>
            </div>
            <div className={S.detail_info}>
              <p className={`${S.detail_text} b3`}>
                {resume.profile.address + ' ' + resume.profile.addressDetail || ''}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* 기본 인적사항 끝 */}
      <hr className={S.divider_line} />
      {/* 이력서 수정 박스 시작 */}
      <div className={S.user_resume_box}>
        <div className={S.user_resume_title}>
          <img src={resumeTitleIcon} alt="이력서 제목" />
          {/*<div className={`${S.resume_title_wrap} text-line-1-wrapper`}>*/}
          {/*  <h4 className="h4">이력서 제목 이력서 제목 이력서 제목 이력서 제목</h4>*/}
          {/*</div>*/}
          {/*<p className="b2">경영·비즈니스</p>*/}
          {/*<span className={S.divider_icon}></span>*/}
          <h6 className="b1">
            이력서{' '}
            <span className={S.progress_rate_text}>
              {_.round(resume.completionRate || 0)}% 완성
            </span>
          </h6>
        </div>
        <div className={S.user_resume_edit}>
          <img src={editIcon} alt="이력서 수정" onClick={() => navigate('/resume')} />
        </div>
      </div>
      {/* 이력서 수정 박스 끝 */}
      {/* 경력 & 학력 박스 시작 */}
      <div className={S.work_edu_wrap}>
        {/* 경력 시작 */}
        <div className={S.user_work_box}>
          <h6 className={S.main_title}>경력</h6>
          <div className={S.work_history}>
            {resume.careers?.length > 0 && (
              <div className={S.history_detail}>
                <div className={S.work_summary}>
                  <div className={S.company_name}>
                    <h6>{resume.careers[0].name || ''}</h6>
                  </div>
                  <span className={S.divider_icon}></span>
                  <p className="b4">{resume.careers[0].position || ''}</p>
                </div>
                <p className={`${S.work_period} b5`}>
                  {resume.careers[0].startAt || ''} ~ {resume.careers[0].endAt || ''}
                </p>
              </div>
            )}
            {resume.careers.length > 1 && (
              <>
                <span className={S.divider_icon}></span>
                <div className={S.history_detail}>
                  <div className={S.work_summary}>
                    <div className={S.company_name}>
                      <h6>{resume.careers[1].name || ''}</h6>
                    </div>
                    <span className={S.divider_icon}></span>
                    <p className="b4">{resume.careers[1].position || ''}</p>
                  </div>
                  <p className={`${S.work_period} b5`}>
                    {resume.careers[1].startAt || ''} ~ {resume.careers[1].endAt || ''}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
        {/* 학력 시작 */}
        <div className={S.user_edu_box}>
          <h6 className={S.main_title}>학력</h6>
          <div className={S.edu_history}>
            {educationSize > 0 && (
              <div className={S.history_detail}>
                <div className={S.edu_summary}>
                  <div className={S.school_name}>
                    <h6>{resume.educations[educationSize - 1].name}</h6>
                  </div>
                  {resume.educations[educationSize - 1].majors.map((edu) => (
                    <>
                      <span className={S.divider_icon}></span>
                      <p className="b4">{edu.name || ''}</p>
                    </>
                  ))}
                </div>
                <p className={`${S.study_period} b5`}>
                  {resume.educations[educationSize - 1].startAt || ''} ~{' '}
                  {resume.educations[educationSize - 1].endAt || ''}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* 경력 & 학력 박스 끝 */}
    </div>
  );
};

export default HomeProfile;

const ProfileImg = styled.div<{ backgroundImage: string }>`
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
